<template>
  <div class="form-group" :class="setPlaceholderClasses">
    <input
      :value="value"
      :id="id"
      :data-min="min"
      :data-max="max"
      class="form-control"
      type="text"
      data-icon-up="fa fa-plus"
      data-icon-down="fa fa-minus"
      ref="input"
    />
    <label :for="id">{{ text }}</label>
  </div>
</template>
<script>
import "@a/bootstrap-touchspin/jquery.bootstrap-touchspin.css";
import "@a/bootstrap-touchspin/jquery.bootstrap-touchspin.js";
import placeholder from "@mixins/placeholder.js";

export default {
  name: "volcan-input-number",
  mixins: [placeholder],
  props: {
    text: String,
    max: Number,
    min: Number,
  },
  data: function () {
    return {
      id: null,
    };
  },
  mounted: function () {
    this.id = "input" + this._uid;
    var spinner = $(this.$refs.input);
    spinner.TouchSpin({
      verticalbuttons: true,
      min: spinner.data("min"),
      max: spinner.data("max"),
      stepinterval: 1,
      verticalupclass: spinner.data("iconup"),
      verticaldownclass: spinner.data("icondown"),
    });
    spinner.on("change", (e) => {
      this.update();
    });
  },
  methods: {
    update() {
      this.$emit("input", this.$refs.input.value);
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-number.vue